import { useEffect, useState } from "react";

export function useImagePreview({ file, fallbackUrl }) {
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (file) {
            const url = URL.createObjectURL(file);
            setPreview(url);
            return () => URL.revokeObjectURL(url);
        }
        setPreview(fallbackUrl || null);
    }, [file, fallbackUrl]);

    return preview;
}
